import VueRouter from "vue-router";
import moment from "moment";

const createRouter = routes => {
	routes = routes.map(route => {
		return {
			...route,
			path: relativeUrl(route.path)
		}
	})

	return new VueRouter({
		mode: 'history',
		routes
	});
}

const formatPrice = number => {
	number = (number/1).toFixed(0).replace('.', ',');
	return 'Rp ' + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

const displayDate = date => {
	return typeof date === "string" ? moment(date).format("YYYY-MM-DD") : null;
}

const isValidDate = date => {
	let d = new Date(date);
	return d instanceof Date && !isNaN(d);
}

const getPage = route => {
	if ('page' in route.query) {
		return route.query.page;
	}

	return '';
}

const moneyTemplate = () => ({
	decimal: ',',
	thousands: '.',
	prefix: 'Rp ',
	precision: 0,
	masked: false,
});

const pruneEmpty = obj => {
	let objCopy = _.cloneDeep(obj);

	for (let prop in objCopy) {
		if (!objCopy[prop] || objCopy[prop].length === 0 || objCopy[prop] === null) {
			delete objCopy[prop];
		} else if (typeof objCopy[prop] === 'object') {
			objCopy[prop] = pruneEmpty(objCopy[prop]);
		}
	}

	return objCopy;
}

const relativeUrl = url => {
	if (url.charAt(0) != '/') {
		url = `/${url}`
	}

	return `${url}`
}

const incrementTailingNumber = str => {
	const tailingNumber = getTailingNumber(str);
	const indexStart = str.indexOf(tailingNumber);
	const indexEnd = indexStart + tailingNumber.length;

	return str.substr(0, indexStart) + incrementPadded(tailingNumber) + str.substr(indexEnd);
}

const getTailingNumber = str => {
	let numerics = [];
	let currentChar = null;

	for (let i = str.length - 1; i >= 0; i--) {
		currentChar = str.charAt(i);

		if (!isNaN(currentChar)) {
			numerics.push(currentChar);
		} 
		else if (numerics.length > 0) {
			break;
		}
	}

	return numerics.reverse().join('');
}

const incrementPadded = num => {
	const length = num.length;
	const increment = "" + ( parseInt(num) + 1 );
	return increment.padStart(length, '0');
}

export {
	createRouter,
	formatPrice,
	getPage,
	moneyTemplate,
	pruneEmpty,
	relativeUrl, 
	displayDate,
	incrementTailingNumber,
	incrementPadded,
	getTailingNumber,
	isValidDate
}
